import { AppBar, Box, Button, Container, Toolbar, Typography, useMediaQuery, Image } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="static" color="primary">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box display="flex" alignItems="center" sx={{ flexGrow: 1 }}>
            <Box component="img" src="/logo512.png" alt="Factur-X" sx={{ mr: 1, height: 36 }} />
            <Typography
              variant="h6"
              component={RouterLink}
              to="/"
              sx={{
                textDecoration: 'none',
                color: 'inherit',
                fontWeight: 700,
                letterSpacing: '0.5px',
              }}
            >
              Convertisseur Factur-X
            </Typography>
          </Box>
          
          {!isMobile && (
            <Box>
              <Button 
                color="inherit" 
                component={RouterLink} 
                to="/"
                sx={{ mx: 1 }}
              >
                Accueil
              </Button>
              <Button 
                color="inherit" 
                component={RouterLink} 
                to="/upload"
                sx={{ mx: 1 }}
              >
                Convertir une facture
              </Button>
            </Box>
          )}

          {isMobile && (
            <Box>
              <Button 
                color="inherit" 
                component={RouterLink} 
                to="/upload"
                size="small"
              >
                Convertir
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
